import React from "react";
import Logo from "./../../Img/logo.webp"

export default function Navber() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img className="logo" alt="leeerob" src={Logo} />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarTogglerDemo02">
          <ul className="navbar-nav mr-0  mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link" href="/">
                Home
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                About
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li className="nav-link">
                  <a className="nav-link" href="/about-us">
                    About Us
                  </a>
                </li>
                <li className="nav-link">
                  <a className="nav-link" href="/md">
                    Managing Director
                  </a>
                </li>
                <li className="nav-link">
                  <a className="nav-link" href="/management">
                    Management Team
                  </a>
                </li>
                <li className="nav-link">
                  <a className="nav-link" href="/executive">
                    Executive team
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                Our Brands
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li className="nav-link" >
                  <a className="nav-link" href="/agrilfoodsltd">
                    Agril Foods Ltd
                  </a>
                </li>
                <li className="nav-link" >
                  <a className="nav-link" href="/georgica-bd-ltd">
                    Georgica BD Ltd
                  </a>
                </li>
                <li className="nav-link" >
                  <a className="nav-link" href="/king-feeds-ltd">
                    King Feeds Ltd
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/contact">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  );
}
